// extracted by mini-css-extract-plugin
export default {"hasCustomColor":"hasCustomColor_Vc2_7","horizantal":"horizantal_U2trB","vertical":"vertical_AO0LJ"};